<div class="flex justify-content-between align-items-center mb-3">
  <div>
<p-button label="Save" class="p-button-outlined ml-2" icon="pi pi-save" size="small" (click)="save()"></p-button>
<p-button label="Cancel" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger" size="small" (click)="ref.close()"></p-button>
  </div>
</div>

<div class="flex justify-content-between align-items-center">
  <p-table #dt1 [value]="list" [scrollable]="true" scrollHeight="500px" styleClass="p-datatable-striped"
    [loading]="loader" responsiveLayout="scroll" class="w-full" styleClass="p-datatable-sm"
    [paginator]="true" [rows]="5" paginatorDropdownAppendTo="body" [rowsPerPageOptions]="[5,10 ,15, 20]"
    (onPage)="load($event)" [rowHover]="true">

    <ng-template pTemplate="header">
      <tr>
        <th>Product Code</th>
        <th>Description</th>
        <th>UOM</th>
        <th>Qty</th>
        <th>Quoted Price</th>
        <th>Freight</th>
        <th>Lead Time(Days)</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data let-i="rowIndex">
      <tr>
        <td>{{data.productCode}}</td>
        <td>{{data.productName}}</td>
        <td>{{data.unitsOfMeasure}}</td>
        <td>{{data.qty}}</td>
        <td>
          <input type="number" pInputText [(ngModel)]="data.quotedPrice"
                 style="width: 100px;" min="0" step="0.01"
                 placeholder="0.00" />
        </td>
        <td>
          <input type="number" pInputText [(ngModel)]="data.freight"
                 style="width: 100px;" min="0" step="0.01"
                 placeholder="0.00" />
        </td>
        <td>
          <input type="text" pInputText [(ngModel)]="data.leadTime"
                 style="width: 100px;"
                 placeholder="0" />
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center p-4">
          <i class="pi pi-info-circle text-blue-500 mr-2"></i>
          No products found. Please add products to the RFQ first.
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>

<p-confirmDialog />
